import { useCallback, type RefObject, type KeyboardEvent } from "react";

interface IUseAdminSidebarKeyboardOptions {
  navRef: RefObject<HTMLElement | null>;
  onSelect: (key: string) => void;
}

export const useAdminSidebarKeyboard = ({
  navRef,
  onSelect,
}: IUseAdminSidebarKeyboardOptions) => {
  return useCallback(
    (e: KeyboardEvent<HTMLElement>) => {
      const nav = navRef.current;
      if (!nav) return;

      const items = Array.from(
        nav.querySelectorAll<HTMLButtonElement>("button[data-key]"),
      );
      if (items.length === 0) return;

      const currentIndex = items.findIndex(
        (item) => item === document.activeElement,
      );

      let nextIndex: number | null = null;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
          break;
        case "ArrowUp":
          e.preventDefault();
          nextIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
          break;
        case "Home":
          e.preventDefault();
          nextIndex = 0;
          break;
        case "End":
          e.preventDefault();
          nextIndex = items.length - 1;
          break;
        default:
          return;
      }

      if (nextIndex !== null) {
        items[nextIndex].focus();
      }
    },
    [navRef, onSelect],
  );
};
